import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import {MediaQueries, CommonBands} from 'vue-media-queries'
import Buefy from 'buefy'

import axios from 'axios'
import VueAxios from 'vue-axios'

import vueDebounce from 'vue-debounce'

Vue.use(VueAxios, axios)

Vue.use(vueDebounce)

const mediaQueries = new MediaQueries({
  bands: CommonBands.Bulma
})

Vue.use(mediaQueries)
Vue.mixin(CommonBands.Bulma.mixin)
Vue.use(Buefy)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  mediaQueries: mediaQueries,
  render: h => h(App)
}).$mount('#app')
